(function () {
  'use strict';

  var cartOverlay = document.getElementById('cartOv');
  var cartDrawer = document.getElementById('cartDraw');
  var searchOverlay = document.getElementById('searchOv');
  var fabricPanel = document.getElementById('fabPanel');
  var fabOverlay = document.getElementById('fabOverlay');
  var lightbox = document.getElementById('lb');
  var mobileNav = document.getElementById('mobileNav');
  var routes = window.routes || {};
  var cartTouchY = null;

  // Keep closed overlays out of keyboard navigation and restore the opener.
  var modalStack = [];
  document.querySelectorAll('#cartDraw, #searchOv, #fabPanel, #contactModal, #lb, #customizationDrawer, #samplesDrawer, #smPopup, #mobileNav').forEach(function (panel) {
    var opener = null;
    var wasOpen = false;
    function syncPanel() {
      var open = panel.classList.contains('open');
      panel.inert = !open;
      panel.setAttribute('aria-hidden', String(!open));
      if (panel === mobileNav) {
        var toggle = document.querySelector('[data-nav-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', String(open));
      } else {
        panel.setAttribute('role', 'dialog');
        panel.setAttribute('aria-modal', 'true');
        if (!panel.hasAttribute('aria-label') && !panel.hasAttribute('aria-labelledby')) {
          panel.setAttribute('aria-label', ({cartDraw:'Shopping cart',searchOv:'Search',fabPanel:'Materials',contactModal:'Contact',lb:'Image viewer',smPopup:'Newsletter'})[panel.id] || 'Product information');
        }
      }
      if (open && !wasOpen) {
        opener = document.activeElement;
        modalStack.push(panel);
        var first = panel.querySelector('button:not([disabled]), input:not([type="hidden"]), a[href], textarea, select');
        if (first) first.focus();
      } else if (!open && wasOpen) {
        modalStack = modalStack.filter(function (item) { return item !== panel; });
        if (opener && opener.isConnected && !opener.closest('[inert]')) opener.focus();
      }
      wasOpen = open;
    }
    syncPanel();
    new MutationObserver(syncPanel).observe(panel, { attributes: true, attributeFilter: ['class'] });
  });
  document.querySelectorAll('.pdp__at_').forEach(function (button, index) {
    var body = button.parentElement.querySelector('.pdp__ab');
    button.setAttribute('aria-expanded', String(button.parentElement.classList.contains('open')));
    if (body) {
      body.id = body.id || 'product-accordion-' + index;
      button.setAttribute('aria-controls', body.id);
    }
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;
    var panel = modalStack[modalStack.length - 1];
    if (!panel) return;
    var focusable = Array.from(panel.querySelectorAll('button, a[href], input, textarea, select, [tabindex="0"]')).filter(function (el) {
      return !el.disabled && !el.closest('[inert]') && el.getClientRects().length;
    });
    var first = focusable[0], last = focusable[focusable.length - 1];
    if (!first) return;
    if (event.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
  });


  function route(name, fallback) {
    return routes[name] || fallback;
  }

  function routeWithSuffix(name, fallback, suffix) {
    var url = route(name, fallback);
    if (url.slice(-suffix.length) === suffix) return url;
    return url + suffix;
  }

  function setCartScrollLock(locked) {
    document.documentElement.classList.toggle('cart-open', locked);
    document.body.classList.toggle('cart-open', locked);
  }

  function toggleCart() {
    var willOpen = !cartDrawer.classList.contains('open');
    cartDrawer.classList.toggle('open', willOpen);
    cartOverlay.classList.toggle('open', willOpen);
    setCartScrollLock(willOpen);
  }

  function openCart() {
    cartDrawer.classList.add('open');
    cartOverlay.classList.add('open');
    setCartScrollLock(true);
  }

  function closeCart() {
    cartDrawer.classList.remove('open');
    cartOverlay.classList.remove('open');
    setCartScrollLock(false);
  }

  function containCartScroll(deltaY, target, event) {
    if (!cartDrawer || !cartDrawer.classList.contains('open') || !cartDrawer.contains(target)) return;
    var scroller = target.closest('.cart__body');
    if (!scroller) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    if (!deltaY) return;
    var atTop = scroller.scrollTop <= 0;
    var atBottom = Math.ceil(scroller.scrollTop + scroller.clientHeight) >= scroller.scrollHeight;
    if ((deltaY < 0 && atTop) || (deltaY > 0 && atBottom)) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  function openSearch() {
    searchOverlay.classList.add('open');
    var input = searchOverlay.querySelector('.search-ov__input');
    if (input) setTimeout(function () { input.focus(); }, 300);
  }

  function closeSearch() {
    searchOverlay.classList.remove('open');
  }

  function closeFabricPanel() {
    if (fabricPanel) fabricPanel.classList.remove('open');
    if (fabOverlay) fabOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  function closeContactModal() {
    var m = document.getElementById('contactModal');
    if (m) m.classList.remove('open');
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('open');
    lightbox.classList.remove('lb--single');
    setLightboxZoom(1);
  }

  function updateCartCount(count) {
    var els = document.querySelectorAll('.cart-count');
    els.forEach(function (el) { el.textContent = count; });
  }

  var cartBusy = false;

  function cartSectionIds() {
    var page = document.querySelector('[data-cart-section-id]');
    return ['cart-drawer'].concat(page ? [page.dataset.cartSectionId] : []);
  }

  function renderCart(cart) {
    var html = cart.sections && cart.sections['cart-drawer'];
    if (!html) throw new Error('Could not refresh your cart. Please reload the page.');
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.getElementById('cartDraw');
    if (!next) throw new Error('Could not refresh your cart. Please reload the page.');
    var note = document.getElementById('cartNoteField');
    var savedNote = note ? note.value : null;
    var terms = document.getElementById('CartDrawerTermsAccepted');
    var accepted = terms && terms.checked;
    cartDrawer.querySelector('.cart__body').innerHTML = next.querySelector('.cart__body').innerHTML;
    var foot = cartDrawer.querySelector('.cart__foot');
    var nextFoot = next.querySelector('.cart__foot');
    foot.innerHTML = nextFoot.innerHTML;
    foot.style.display = nextFoot.style.display;
    cartDrawer.dataset.itemCount = next.dataset.itemCount;
    cartDrawer.dataset.discountCodes = next.dataset.discountCodes;
    if (savedNote !== null) document.getElementById('cartNoteField').value = savedNote;
    document.getElementById('CartDrawerTermsAccepted').checked = Boolean(accepted);
    updateCartCount(next.dataset.itemCount);
    var page = document.querySelector('[data-cart-section-id]');
    if (page && cart.sections[page.dataset.cartSectionId]) {
      var form = page.querySelector('form');
      var noteValue = form && form.querySelector('[name="note"]') ? form.querySelector('[name="note"]').value : null;
      var termsValue = page.querySelector('#CartTermsAccepted')?.checked;
      var quantityDrafts = new Map(Array.from(page.querySelectorAll('[name="updates[]"]')).filter(function (input) { return input.value !== input.defaultValue; }).map(function (input) { return [input.dataset.cartItem, input.value]; }));
      var updated = new DOMParser().parseFromString(cart.sections[page.dataset.cartSectionId], 'text/html').querySelector('[data-cart-page]');
      if (updated) {
        page.innerHTML = updated.innerHTML;
        page.querySelectorAll('[name="updates[]"]').forEach(function (input) { if (quantityDrafts.has(input.dataset.cartItem)) input.value = quantityDrafts.get(input.dataset.cartItem); });
        if (noteValue !== null && page.querySelector('[name="note"]')) page.querySelector('[name="note"]').value = noteValue;
        if (page.querySelector('#CartTermsAccepted')) page.querySelector('#CartTermsAccepted').checked = Boolean(termsValue);
      }
    }
    if (cartBusy) document.querySelectorAll('.cart__qty-btn, .cart__item-rm, .cart__checkout, .cart-page__checkout').forEach(function (button) { button.disabled = true; });
  }

  async function cartRequest(name, fallback, body) {
    var response = await fetch(routeWithSuffix(name, fallback, '.js'), {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, signal: AbortSignal.timeout(15000),
      body: JSON.stringify(Object.assign({}, body, { sections: cartSectionIds(), sections_url: window.location.pathname }))
    });
    var data = await response.json();
    if (!response.ok) throw new Error(data.description || 'Could not update your cart. Please try again.');
    return data;
  }

  async function applyTradeDiscount(cart) {
    if (cartDrawer.dataset.tradeCustomer !== 'true') return cart;
    // Shopify checks approved membership and product eligibility, and calculates the prices.
    var html = cart.sections && cart.sections['cart-drawer'];
    var next = html && new DOMParser().parseFromString(html, 'text/html').getElementById('cartDraw');
    return cartRequest('cart_update_url', '/cart/update', { discount: (next || cartDrawer).dataset.discountCodes });
  }

  async function changeCart(action) {
    if (cartBusy) return;
    cartBusy = true;
    var controls = document.querySelectorAll('.cart__qty-btn, .cart__item-rm, .cart__checkout, .cart-page__checkout');
    controls.forEach(function (button) { button.disabled = true; });
    try {
      document.querySelectorAll('[data-cart-error]').forEach(function (el) { el.remove(); });
      var cart = await action();
      renderCart(cart);
      if (cartDrawer.dataset.tradeCustomer === 'true') {
        try { renderCart(await applyTradeDiscount(cart)); }
        catch (error) { showCartError('Your cart was updated, but trade pricing could not refresh. Please reload before checkout.'); }
      }
    }
    catch (error) { showCartError(error.message); throw error; }
    finally {
      cartBusy = false;
      document.querySelectorAll('.cart__qty-btn, .cart__item-rm, .cart__checkout, .cart-page__checkout').forEach(function (button) { button.disabled = false; });
    }
  }

  function fetchCart() {
    return changeCart(async function () {
      var url = route('cart_url', '/cart') + '?sections=' + cartSectionIds().join(',');
      var response = await fetch(url, { signal: AbortSignal.timeout(15000) });
      if (!response.ok) throw new Error('Could not refresh your cart. Please try again.');
      return { sections: await response.json() };
    }).catch(function () {});
  }

  function setAddBtnState(state) {
    var btn = document.getElementById('pdpAddBtn');
    if (!btn) return;
    if (state === 'loading') {
      btn.disabled = true;
      btn.dataset.originalText = btn.textContent;
      btn.textContent = 'Adding\u2026';
    } else if (state === 'error') {
      btn.disabled = false;
      btn.textContent = btn.dataset.originalText || 'Add to Cart';
    } else {
      btn.disabled = false;
      btn.textContent = btn.dataset.originalText || 'Add to Cart';
    }
  }

  function showCartError(message) {
    document.querySelectorAll('[data-cart-error]').forEach(function (el) { el.remove(); });
    [cartDrawer.querySelector('.cart__body'), document.querySelector('[data-cart-page]')].filter(Boolean).forEach(function (body) {
      var el = document.createElement('p');
      el.dataset.cartError = '';
      el.setAttribute('role', 'alert');
      el.style.cssText = 'background:#fee;color:#b91c1c;padding:12px 16px;margin:12px 0;';
      el.textContent = message;
      body.prepend(el);
    });
  }

  function addToCart(variantId, quantity, properties) {
    if (cartBusy) return;
    setAddBtnState('loading');
    var item = { id: variantId, quantity: quantity || 1 };
    if (properties && Object.keys(properties).length) item.properties = properties;
    openCart();
    changeCart(function () { return cartRequest('cart_add_url', '/cart/add', { items: [item] }); })
      .then(function () { setAddBtnState('done'); })
      .catch(function () { setAddBtnState('error'); });
  }

  function removeFromCart(keyOrLine, useLine) {
    var body = useLine ? { line: parseInt(keyOrLine, 10), quantity: 0 } : { id: keyOrLine, quantity: 0 };
    return changeCart(function () { return cartRequest('cart_change_url', '/cart/change', body); }).catch(function () {});
  }

  function updateQuantity(line, newQty) {
    if (newQty < 1) return removeFromCart(line, true);
    return changeCart(function () { return cartRequest('cart_change_url', '/cart/change', { line: parseInt(line, 10), quantity: newQty }); }).catch(function () {});
  }

  function escapeHtml(str) {
    if (!str) return '';
    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function toggleAcc(el) {
    var item = el.parentElement;
    var isOpen = item.classList.contains('open');
    var span = el.querySelector('span');
    item.classList.toggle('open', !isOpen);
    el.setAttribute('aria-expanded', String(!isOpen));
    if (span) span.textContent = isOpen ? '+' : '\u2212';
  }

  function pickSwatch(el, name) {
    el.parentElement.querySelectorAll('.picker-sw').forEach(function (s) {
      s.classList.remove('active');
      s.setAttribute('aria-pressed', s === el ? 'true' : 'false');
    });
    el.classList.add('active');
    var chosen = document.getElementById('pickerChosen');
    if (chosen) chosen.textContent = name;
  }

  function pickSize(el) {
    el.parentElement.querySelectorAll('.size-opt').forEach(function (s) {
      s.classList.remove('active');
      s.setAttribute('aria-pressed', s === el ? 'true' : 'false');
    });
    el.classList.add('active');
  }

  var lbImages = [];
  var lbIdx = 0;
  var lbZoom = 1;

  function setLightboxZoom(value) {
    if (!lightbox) return;
    var img = document.getElementById('lbImg');
    if (img && lbZoom <= 1.01) {
      var visibleWidth = Math.round(img.getBoundingClientRect().width);
      if (visibleWidth > 0) img.dataset.lbBaseWidth = visibleWidth;
    }
    lbZoom = value > 1 ? 2.6 : 1;
    lightbox.classList.toggle('zoomed', lbZoom > 1.01);
    if (img) {
      var currentWidth = Math.round(img.getBoundingClientRect().width);
      var fallbackWidth = Math.min(window.innerWidth * 0.96, img.naturalWidth || window.innerWidth);
      var baseWidth = Number(img.dataset.lbBaseWidth || currentWidth || fallbackWidth);
      var zoomedWidth = Math.max(baseWidth * lbZoom, Math.min((img.naturalWidth || baseWidth * lbZoom), window.innerWidth * 1.75));
      img.style.maxWidth = lbZoom > 1.01 ? 'none' : '';
      img.style.maxHeight = lbZoom > 1.01 ? 'none' : '';
      img.style.width = lbZoom > 1.01 ? Math.round(zoomedWidth) + 'px' : '';
    }
  }

  function openLightbox(images, idx) {
    if (!lightbox || !images || !images.length) return;
    lbImages = images;
    lbIdx = idx || 0;
    lightbox.classList.add('open');
    lightbox.classList.toggle('lb--single', lbImages.length <= 1);
    setLightboxZoom(1);
    updateLightbox();
  }

  function updateLightbox() {
    var img = document.getElementById('lbImg');
    var counter = document.getElementById('lbCount');
    if (img) img.src = lbImages[lbIdx];
    if (img) delete img.dataset.lbBaseWidth;
    if (counter) counter.textContent = (lbIdx + 1) + ' / ' + lbImages.length;
  }

  function lightboxNav(dir) {
    if (lbImages.length <= 1) return;
    lbIdx = (lbIdx + dir + lbImages.length) % lbImages.length;
    setLightboxZoom(1);
    updateLightbox();
  }

  function initScrollReveal() {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.reveal').forEach(function (el) {
      observer.observe(el);
    });
  }

  function initPredictiveSearch() {
    var input = searchOverlay.querySelector('.search-ov__input');
    var resultsContainer = document.getElementById('searchResults');
    if (!input || !resultsContainer) return;

    var debounceTimer;
    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      var query = input.value.trim();
      if (query.length < 2) {
        resultsContainer.innerHTML = '';
        return;
      }
      debounceTimer = setTimeout(function () {
        fetch(routeWithSuffix('predictive_search_url', '/search/suggest', '.json') + '?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=12')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = data.resources.results.products;
            if (!products || products.length === 0) {
              resultsContainer.innerHTML = '<p style="text-align:center;color:var(--if);font-family:var(--fb);font-style:italic;padding:20px 0;grid-column:1/-1">No results found.</p>';
              return;
            }
            var html = '';
            products.forEach(function (product) {
              html += '<a class="search-ov__result" href="' + product.url + '">';
              if (product.image) {
                html += '<div class="search-ov__result-img"><img src="' + product.image + '" alt="' + escapeHtml(product.title) + '"></div>';
              }
              html += '<div class="search-ov__result-name">' + escapeHtml(product.title) + '</div>';
              html += '</a>';
            });
            resultsContainer.innerHTML = html;
          })
          .catch(function (err) {
            console.error('Predictive search error:', err);
            resultsContainer.innerHTML = '';
          });
      }, 300);
    });
  }

  document.addEventListener('click', function (e) {
    var target = e.target;

    if (target.closest('[data-search-toggle]')) {
      e.preventDefault();
      openSearch();
    }
    if (target.closest('[data-search-close]')) {
      closeSearch();
    }
    if (target.closest('[data-cart-toggle]')) {
      e.preventDefault();
      toggleCart();
    }
    if (target.closest('[data-cart-close]')) {
      closeCart();
      if (mobileNav) mobileNav.classList.remove('open');
    }
    if (target.closest('[data-fab-close]')) {
      if (window.SMBackFabricPanelDetail && window.SMBackFabricPanelDetail()) return;
      closeFabricPanel();
    }
    if (target.closest('.fab-panel__overlay')) {
      closeFabricPanel();
    }
    if (target.closest('[data-lb-close]')) {
      closeLightbox();
    }
    if (target.closest('[data-lb-prev]')) {
      if (lbImages.length <= 1) return;
      lightboxNav(-1);
    }
    if (target.closest('[data-lb-next]')) {
      if (lbImages.length <= 1) return;
      lightboxNav(1);
    }
    if (target.closest('[data-lb-stage]')) {
      setLightboxZoom(lbZoom > 1 ? 1 : 2.6);
    }
    if (target.closest('[data-remove-key]')) {
      var rmBtn = target.closest('[data-remove-key]');
      var line = rmBtn.dataset.line;
      if (line) {
        removeFromCart(line, true);
      } else {
        removeFromCart(rmBtn.dataset.removeKey, false);
      }
    }
    if (target.closest('.cart__qty-minus')) {
      var minusBtn = target.closest('.cart__qty-minus');
      var lineNum = parseInt(minusBtn.dataset.line, 10);
      var cartItem = minusBtn.closest('.cart__item');
      var qtySpan = cartItem ? cartItem.querySelector('.cart__qty-num') : null;
      var currentQty = qtySpan ? parseInt(qtySpan.textContent, 10) : 1;
      updateQuantity(lineNum, currentQty - 1);
    }
    if (target.closest('.cart__qty-plus')) {
      var plusBtn = target.closest('.cart__qty-plus');
      var lineNum2 = parseInt(plusBtn.dataset.line, 10);
      var cartItem2 = plusBtn.closest('.cart__item');
      var qtySpan2 = cartItem2 ? cartItem2.querySelector('.cart__qty-num') : null;
      var currentQty2 = qtySpan2 ? parseInt(qtySpan2.textContent, 10) : 1;
      updateQuantity(lineNum2, currentQty2 + 1);
    }
    if (target.closest('.pdp__at_')) {
      toggleAcc(target.closest('.pdp__at_'));
    }
    if (target.closest('.picker-sw')) {
      var sw = target.closest('.picker-sw');
      pickSwatch(sw, sw.dataset.value || '');
    }
    if (target.closest('.size-opt')) {
      pickSize(target.closest('.size-opt'));
    }
    if (target.closest('.pdp__gi')) {
      var img = target.closest('.pdp__gi');
      var allImgs = Array.from(document.querySelectorAll('.pdp__g .pdp__gi')).filter(function(i) {
        return window.getComputedStyle(i).display !== 'none';
      });
      var imgs = allImgs.map(function (i) { return i.src; });
      var idx = allImgs.indexOf(img);
      openLightbox(imgs, idx >= 0 ? idx : 0);
    }
    if (target.closest('[data-nav-toggle]')) {
      if (mobileNav) mobileNav.classList.toggle('open');
    }
    if (target.closest('.nav__mobile a')) {
      if (mobileNav) mobileNav.classList.remove('open');
    }
    if (target.closest('.fab-card') && !target.closest('[data-fab-info]')) {
      var card = target.closest('.fab-card');
      if (card.dataset.fabAvailable === 'false') {
        var infoId = card.getAttribute('data-fab-info-card');
        var infoButton = infoId ? document.querySelector('[data-fab-info="' + infoId + '"]') : null;
        if (infoButton) infoButton.click();
        return;
      }
      var val = card.dataset.fabValue;
      if (val) {
        var swatchSelector = '.picker-sw[data-value="' + (window.CSS && CSS.escape ? CSS.escape(val) : val) + '"]';
        var swatch = document.querySelector(swatchSelector);
        if (swatch) swatch.click();
        var panelSw = document.querySelector('.picker-panel-sw');
        if (panelSw) {
          var cardImg = card.querySelector('.fab-card__img');
          if (cardImg) panelSw.style.cssText = cardImg.style.cssText;
        }
        if (fabOverlay) fabOverlay.classList.remove('open');
        closeFabricPanel();
      }
    }
  });


  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeLightbox();
      closeSearch();
      closeFabricPanel();
      closeContactModal();
      closeCart();
      if (mobileNav) mobileNav.classList.remove('open');
    }
    if (lightbox && lightbox.classList.contains('open')) {
      if (lbImages.length > 1 && e.key === 'ArrowRight') lightboxNav(1);
      if (lbImages.length > 1 && e.key === 'ArrowLeft') lightboxNav(-1);
      if (e.key === '0') setLightboxZoom(1);
    }
  });

  if (cartOverlay) {
    cartOverlay.addEventListener('click', closeCart);
  }
  if (cartDrawer) {
    cartDrawer.addEventListener('wheel', function (e) {
      containCartScroll(e.deltaY, e.target, e);
    }, { passive: false });
    cartDrawer.addEventListener('touchstart', function (e) {
      cartTouchY = e.touches && e.touches.length ? e.touches[0].clientY : null;
    }, { passive: true });
    cartDrawer.addEventListener('touchmove', function (e) {
      if (cartTouchY === null || !e.touches || !e.touches.length) return;
      var nextY = e.touches[0].clientY;
      containCartScroll(cartTouchY - nextY, e.target, e);
      cartTouchY = nextY;
    }, { passive: false });
  }

  function initGalerie() {
    var roots = document.querySelectorAll('[data-galerie-index]');
    roots.forEach(function (root) {
      if (root.__smGalerieInitialized) return;
      root.__smGalerieInitialized = true;

      var buttons = root.querySelectorAll('[data-galerie-filter]');
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-galerie-card]'));
      var empty = root.querySelector('[data-galerie-empty]');
      var pagination = root.querySelector('[data-galerie-pagination]');
      var perPage = parseInt(root.getAttribute('data-galerie-per-page') || '12', 10);
      var activeFilter = 'all';
      var currentPage = 1;

      function matchingCards() {
        return cards.filter(function (card) {
          return activeFilter === 'all' || card.getAttribute('data-category') === activeFilter;
        });
      }

      function renderPagination(totalPages) {
        if (!pagination) return;
        pagination.innerHTML = '';
        pagination.hidden = totalPages < 2;
        if (totalPages < 2) return;

        var previous = document.createElement('button');
        previous.type = 'button';
        previous.textContent = 'Previous';
        previous.disabled = currentPage === 1;
        previous.addEventListener('click', function () {
          currentPage = Math.max(1, currentPage - 1);
          applyGalerieState();
        });
        pagination.appendChild(previous);

        for (var page = 1; page <= totalPages; page += 1) {
          var pageButton = document.createElement('button');
          pageButton.type = 'button';
          pageButton.textContent = String(page);
          pageButton.className = page === currentPage ? 'current' : '';
          pageButton.setAttribute('aria-label', 'Go to galerie page ' + page);
          pageButton.addEventListener('click', function (event) {
            currentPage = parseInt(event.currentTarget.textContent, 10);
            applyGalerieState();
          });
          pagination.appendChild(pageButton);
        }

        var next = document.createElement('button');
        next.type = 'button';
        next.textContent = 'Next';
        next.disabled = currentPage === totalPages;
        next.addEventListener('click', function () {
          currentPage = Math.min(totalPages, currentPage + 1);
          applyGalerieState();
        });
        pagination.appendChild(next);
      }

      function applyGalerieState() {
        var filtered = matchingCards();
        var totalPages = Math.max(1, Math.ceil(filtered.length / perPage));
        currentPage = Math.min(currentPage, totalPages);
        var first = (currentPage - 1) * perPage;
        var last = first + perPage;

        cards.forEach(function (card) { card.hidden = true; });
        filtered.slice(first, last).forEach(function (card) { card.hidden = false; });

        if (empty) empty.hidden = filtered.length > 0;
        renderPagination(totalPages);
      }

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          activeFilter = button.getAttribute('data-galerie-filter') || 'all';
          currentPage = 1;
          buttons.forEach(function (item) { item.classList.toggle('is-active', item === button); });
          applyGalerieState();
        });
      });

      applyGalerieState();
    });

    document.querySelectorAll('[data-copy-link]').forEach(function (button) {
      if (button.__smCopyLinkInitialized) return;
      button.__smCopyLinkInitialized = true;
      button.addEventListener('click', function () {
        var url = button.getAttribute('data-copy-link') || window.location.href;
        if (!navigator.clipboard) return;
        navigator.clipboard.writeText(url).then(function () {
          var original = button.textContent;
          button.textContent = 'Copied';
          setTimeout(function () { button.textContent = original; }, 1400);
        });
      });
    });
  }

  initScrollReveal();
  initPredictiveSearch();
  initGalerie();
  if (cartDrawer && cartDrawer.dataset.tradeCustomer === 'true') fetchCart();


  // Re-init scroll reveal when Shopify theme editor re-renders a section
  document.addEventListener('shopify:section:load', function () {
    initScrollReveal();
    initGalerie();
  });
  document.addEventListener('shopify:block:select', function () {
    initScrollReveal();
  });

  window.SM = {
    addToCart: addToCart,
    removeFromCart: removeFromCart,
    fetchCart: fetchCart,
    openLightbox: openLightbox,
    toggleAcc: toggleAcc,
    pickSwatch: pickSwatch,
    pickSize: pickSize,
    updateQuantity: updateQuantity
  };
})();
